import axios from '../utils/axios';

export default function getMailerAudienceCount(adminId, id, params) {
    return (
        axios.get(`/admin/${adminId}/tag-mailers/${id}/count`, { params })
    )
}
